import axios from "axios";
import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";

class   StaffForm extends Component{

    state = {
        id : null,
        profileId : null,
        categoryId : null,
        name : "",
        email : "",
        tel : "",
        password : "",
        adress : "",
        avatar : "",
        error : "",

        title : "",
        profiles : [],
        categories : [],
        userprofiles : [],
        btn  : false
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    async getprofiles () {
        var user = JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')) : {};
        var society = localStorage.getItem("society") ?  JSON.parse(localStorage.getItem("society")) : {};
        var societ = society.userprofile ?  society.userprofile.profile ? society.userprofile.profile.society ? society.userprofile.profile.society.id : null : null : null;
        
      var mysociety = await axios.get('societies/' + societ);
        
        if(mysociety.status === 200)
        {
            this.setState({profiles : mysociety.data.profiles, loading : true})
        }
    }

    async getCategories(){
        let data = await axios.get("categories");
        if(data.status == 200){
            this.setState({
                categories : data.data
            })
        }
    }

    async getUserprofiles(){
        let id =  this.props.formData ? this.props.formData.id : false;
        if(id){
            let data = await axios.get("userprofiles/" + id)
            if(data.status == 200){
                this.setState({
                    userprofiles : data.data
                })
            }
        }else{
            this.setState({ userprofiles : []})
        }
    }

    storeUserprofile = () => {
        axios.post('userprofiles', { status  : "Actif", userId : this.state.id, profileId : this.state.profileId, categoryId : this.state.categoryId }).then((response) =>{
            this.getUserprofiles()
        }).catch((error) => {
            this.setState({
                error : error.response.data.msg,
            })
        })
    }

    deleteUserprofile = (id) => {
        axios .delete("userprofiles/" + id)
          .then((response) => {
            this.getUserprofiles();
          })  .catch((error) => {});
      };

    storeUser = (e) =>{
        e.preventDefault();

        this.setState({
            btn : !this.state.btn
        })

        var country = localStorage.getItem("country") ?  JSON.parse(localStorage.getItem("country")) : {};
        var society = localStorage.getItem("society") ?  JSON.parse(localStorage.getItem("society")) : {};
        var societ = society.userprofile ?  society.userprofile.profile ? society.userprofile.profile.society ? society.userprofile.profile.society.id : null : null : null;
        
        var data = {
                profileId : this.state.profileId ? this.state.profileId : "1",
                categoryId : this.state.categoryId ? this.state.categoryId : null,
                name : this.state.name,
                email : this.state.email ? this.state.email : null,
                tel : this.state.tel ? this.state.tel : null,
                type : "Physique",
                password : "123",
                country : country?.country,
                countryData : country?.country,
                countryCode : country?.countryCode?.toLowerCase(),
                region : country?.regionName,
                city : country?.city,
                adress : this.state.adress,
                societyId : societ
        }

        var request = this.state.id ? axios.put('users/'+this.state.id, data) : axios.post('users', data);
        request.then((response) =>{
            this.setState({
                btn : !this.state.btn
            })
            this.props.showModal()
        }).catch((error) => {
            this.setState({
                error : error.response.data.msg,
                btn : !this.state.btn
            })
        })
    }

    edit=()=>  {
        this.form()
        this.getprofiles();
        this.getCategories();
        this.getUserprofiles();
    }

    form=()=>{

        this.setState({
            id: this.props.formData ? this.props.formData.id : null,
            profileId: this.props.formData ? this.props.formData.userprofile ? this.props.formData.userprofile.profile ? this.props.formData.userprofile.profile.id : "" : "" : "",
            categoryId: this.props.formData ? this.props.formData.userprofile ? this.props.formData.userprofile.category ? this.props.formData.userprofile.category.id : "" : "" : "",
            name: this.props.formData ? this.props.formData.name : "",
            email: this.props.formData ? this.props.formData.email : "",
            tel: this.props.formData ? this.props.formData.tel : "",
            type: this.props.formData ? this.props.formData.type : "",
            adress: this.props.formData ? this.props.formData.adress : "",
            title : this.props.formData ? "Modifier staff" : "Ajouter staff",
            error : "",
        })
    }

    render(){

        return(
            <div>
            <Modal
                show={this.props.isModal}
                onHide={this.props.showModal}
                size="lg"
                onEntered={this.edit}
                backdrop={"static"}>
                <Modal.Header>
                    <Modal.Title>{ this.state.title}</Modal.Title>
                </Modal.Header>
                <form onSubmit={this.storeUser}>
                <Modal.Body className="row">
                    <div className="text-center text-danger text-small small">{ this.state.error }</div>
                    <div className="col-md-6 mt-2 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Nom</label>
                            <div className="position-relative mt-1">
                                <input type="text" className="form-control" placeholder=""  onChange={this.handleInput} name="name"  value={this.state.name} id="nom-id-icon" />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-2 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Email</label>
                            <div className="position-relative mt-1">
                                <input type="text" className="form-control" placeholder=""  onChange={this.handleInput} name="email"  value={this.state.email} id="nom-id-icon" />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-2 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Téléphone</label>
                            <div className="position-relative mt-1">
                                <input type="number" className="form-control"  name="tel"  placeholder="" onChange={this.handleInput} value={this.state.tel} id="nom-id-icon" />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-2 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Adresse</label>
                            <div className="position-relative mt-1">
                                <input type="text" className="form-control" placeholder=""  onChange={this.handleInput} name="adress"  value={this.state.adress} id="nom-id-icon" />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-2 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Profil</label>
                            <div className="position-relative mt-1">
                                <select id="profileId" name="profileId" required={true}  value={this.state.profileId} onChange={this.handleInput} className="form-select">
                                    <option value="">...</option>
                                    {
                                        this.state.profiles.map((profile) => {
                                            return(
                                                <option key={ profile.id } value={ profile.id}>{ profile.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
   
                    <div className="col-md-6 mt-2 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Service</label>
                            <div className="position-relative mt-1">
                                <select id="categoryId" name="categoryId" required={true}  value={this.state.categoryId} onChange={this.handleInput} className="form-select">
                                    <option value="">...</option>
                                    {
                                        this.state.categories.filter( data => data.parentId != null ).map((category) => {
                                            return(
                                                <option key={ category.id } value={ category.id}>{ category.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                    </div>

                    {
                        this.state.userprofiles.length > 0 && (
                            <div className="text-end"><button type="button" className="btn btn-outline-primary btn-sm m-2" onClick={ () => this.storeUserprofile()}><i className="bi bi-house-heart"></i> Attacher </button></div>
                        )
                    }
 


                    <div className={"meta-bottom mt-2" }>
                        {
                            this.state.userprofiles.map((userprofile) => {
                                return(
                                    <span className=" border border-1 px-1 mx-2 rounded-4" onClick={ () => this.deleteUserprofile(userprofile.id)}><Link to="#" className="text-dark">{ userprofile?.profile?.name} <i className={ userprofile?.category?.icone }></i> { userprofile?.category?.name} </Link></span>
                                 )
                            })
                        }
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button onClick={this.props.showModal} type="button" className="btn btn-outline-secondary btn-sm"><i className="bi bi-corner-down-left"></i> Fermer</button>
                    <button type="submit" className="btn btn-sm btn-outline-primary" disabled={ this.state.btn }><i className="bi bi-check"></i> Sauvegarder</button>
                </Modal.Footer>
                </form>
            </Modal>


        </div>
        )
    }
}
export default StaffForm;
